import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { IconExternalLink } from '@lightspeed/flame/Icon/ExternalLink';

import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

const SectionHelp = () => {
  const href =
    'https://retail-support.lightspeedhq.com/hc/en-us/articles/228840747-Creating-purchase-orders#h_01HNGAJQ8AZ7T5T773RSACQS7B';
  return (
    <div style={{ position: 'absolute', top: '9px', right: '9px' }}>
      <TooltipHelp
        title="Adjusting costs"
        content="If you have additional question regarding adjusting cost to record your landed cost, visit the help center."
        button={
          <Button href={href} target="_blank" rel="nofollow noopener noreferrer">
            <IconExternalLink /> Go to Help Center
          </Button>
        }
        placement="top-end"
      />
    </div>
  );
};

export default SectionHelp;
